<template>
    <div
        class="grid grid-cols-2 gap-4 gap-y-8 md:gap-8"
        :class="`md:grid-cols-${parent.columns || 3}`"
    >
        <CategoryCard
            v-for="(category, index) in children"
            :key="index"
            :category="category"
        />
    </div>
</template>

<script>
import CategoryCard from '@/components/CategoryCard';

export default {

    components: {
        CategoryCard,
    },

    props: {
        parent: {
            type: Object,
            required: true,
        },
        children: {
            type: Array,
            required: true,
        },
    },

};
</script>

<style lang="scss" scoped>
</style>
